"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOrgIoTSensorEvents = void 0;
const GQLQueryArrayHook_1 = __importDefault(require("@opsbase/react-gql/GQLQueryArrayHook/GQLQueryArrayHook"));
const GQLType_1 = __importDefault(require("@opsbase/react-gql/GQLType"));
const OrgIoTSensorEvents = {
    type: GQLType_1.default.QUERY,
    name: 'iotSensorEvents',
    params: { sensors: 'JSON', from: 'ISODate', to: 'ISODate' },
};
exports.useOrgIoTSensorEvents = (0, GQLQueryArrayHook_1.default)(OrgIoTSensorEvents);
exports.default = exports.useOrgIoTSensorEvents;
